class Customer extends Events
{
  constructor()
  {
    super();

    this.data = null;
    this.residentialCountry = window.theme.customer
      ? window.theme.customer.residentialCountry
      : null;
  }

  init()
  {
    this.initEvents();
    this.initCurations();
    this.residentialCountrySelect = document.querySelector('#customer-residential-country');

    if (document.querySelector('#customer-residential-country')) {
      document.querySelector('.customer-country-content-save').addEventListener('click', e => {
        e.preventDefault();

        this.updateResidentialCountry(document.querySelector('#customer-residential-country').value);
      });
    }

    this.treatmentCountrySelect = document.querySelector('#customer-treatment-country');

    if (this.treatmentCountrySelect) {
      // Pre-populate with the resolved treatment country (cache + metafield).
      const currentTreatment = window.app.treatmentCountry.getSelection().country;
      if (currentTreatment) {
        this.treatmentCountrySelect.value = currentTreatment;
      }

      // The AU state dropdown lives next to the treatment country select on the
      // account page. Reveal it live as the country select changes (before save).
      this.treatmentStateWrapper = document.querySelector('.customer-treatment-country-section .treatment-state-wrapper');
      this.treatmentStateSelect = this.treatmentStateWrapper
        ? this.treatmentStateWrapper.querySelector('select')
        : null;

      const syncAccountState = () => {
        if (!this.treatmentStateWrapper) {
          return;
        }

        if (this.treatmentCountrySelect.value === 'AU') {
          this.treatmentStateWrapper.removeAttribute('hidden');
        } else {
          this.treatmentStateWrapper.setAttribute('hidden', '');
        }
      };

      this.treatmentCountrySelect.addEventListener('change', e => syncAccountState());
      syncAccountState();

      document.querySelector('.customer-treatment-country-content-save').addEventListener('click', e => {
        e.preventDefault();

        const country = this.treatmentCountrySelect.value;

        this.updateTreatmentCountry(country);

        if (country === 'AU' && this.treatmentStateSelect) {
          window.app.treatmentCountry.setState(this.treatmentStateSelect.value);
        }
      });
    }

    document.querySelectorAll('.form-account-button-login').forEach(button => {
      const form = button.closest('form');

      form.addEventListener('submit', e => {
        app.session.put('performed_login', 1);
      });
    });
  }

  initEvents ()
  {
    this.on('fetch', data => {
      this.data = data;
      console.log('customer', data);

      if (document.querySelector('#customer-residential-country')
        && typeof(data.customer) !== 'undefined'
        && typeof(data.customer.metafields) !== 'undefined'
        && typeof(data.customer.metafields['custom.residential_country_iso_code']) !== 'undefined'
      ) {
        document.querySelector('#customer-residential-country').value = data.customer.metafields['custom.residential_country_iso_code'];
      }
    });
  }

  async initCurations () {
    if (!window.theme.customer) {
      return;
    }

    // Check cache first
    const cachedCurations = app.cache.get(window.cacheKeys.customerCurations);

    if (cachedCurations) {
      this.curationsData = cachedCurations;
      this.emit('curations', cachedCurations);
      return cachedCurations;
    }

    if (!window.customBackend.customerEmail) {
      return;
    }    

    try {
      const response = await fetch('https://app.donornetwork.com/api/shopify/customer/curations', {
        headers: {
          'Content-Type': 'application/json',
          ...app.apiHeaders()
        }
      });

      const data = await response.json();
      const curations = data.data || [];

      // Cache for 1 day (86400 seconds) even if empty
      app.cache.put(window.cacheKeys.customerCurations, curations, 86400);

      this.curationsData = curations;
      this.emit('curations', curations);

      return curations;
    } catch (error) {
      console.error('Failed to fetch customer curations:', error);

      // Cache empty array to prevent repeated API calls on error
      app.cache.put(window.cacheKeys.customerCurations, [], 86400);

      return [];
    }
  }

  updateResidentialCountry (country)
  {
    if (this.residentialCountrySelect) {
      document.querySelector('.customer-country-loader').classList.remove('hidden');
      document.querySelector('.customer-country-error').classList.add('hidden');
      document.querySelector('.customer-country-content').classList.add('hidden');
    }

    return fetch('https://app.donornetwork.com/api/shopify/customer/residential-country', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...app.apiHeaders()
      },
      body: JSON.stringify({
        country: country.toLowerCase().trim()
      })
    }).then(res => res.json())
      .then(res => {
        if (this.residentialCountrySelect) {
          document.querySelector('.customer-country-loader').classList.add('hidden');
          document.querySelector('.customer-country-error').classList.add('hidden');
          document.querySelector('.customer-country-content').classList.remove('hidden');
        }

        if (res.success && res.customer) {
          window.theme.customer.residentialCountry = res.customer.metafields['custom.residential_country_iso_code'];
          app.customer.residentialCountry = res.customer.metafields['custom.residential_country_iso_code'];

          broadcast('residential_country_change', window.theme.customer.residentialCountry);
        }

        return res;
      }).catch(err => {
        console.error(err);

        if (this.residentialCountrySelect) {
          document.querySelector('.customer-country-loader').classList.add('hidden');
          document.querySelector('.customer-country-content').classList.add('hidden');
          document.querySelector('.customer-country-error').classList.remove('hidden');
        }

        return err;
      });
  }

  updateTreatmentCountry (country)
  {
    if (!country) {
      return;
    }

    // Save using the existing treatment country system
    window.app.treatmentCountry.set(country);

    // Show saved confirmation
    const savedMessage = document.querySelector('.customer-treatment-country-content-saved');
    if (savedMessage) {
      savedMessage.classList.remove('hidden');

      // Hide the message after 3 seconds
      setTimeout(() => {
        savedMessage.classList.add('hidden');
      }, 3000);
    }
  }

  // Pure metafield write for treatment country — called from TreatmentCountry.set()
  // so both storefront selectors and the account save flow through one place.
  saveTreatmentCountry (country)
  {
    if (!country || !window.customBackend || !window.customBackend.customerEmail) {
      return Promise.resolve();
    }

    return fetch('https://app.donornetwork.com/api/shopify/customer/treatment-country', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...app.apiHeaders()
      },
      body: JSON.stringify({
        country: ('' + country).toLowerCase().trim()
      })
    }).then(res => res.json())
      .catch(err => {
        console.error('Failed to save treatment country', err);
      });
  }

  // Pure metafield write for the AU state. Empty/cleared state is not posted —
  // it is only relevant while Australia is selected, so a stale value is harmless.
  saveTreatmentState (state)
  {
    if (!state || !window.customBackend || !window.customBackend.customerEmail) {
      return Promise.resolve();
    }

    return fetch('https://app.donornetwork.com/api/shopify/customer/treatment-state', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...app.apiHeaders()
      },
      body: JSON.stringify({
        state: ('' + state).toUpperCase().trim()
      })
    }).then(res => res.json())
      .catch(err => {
        console.error('Failed to save treatment state', err);
      });
  }
}